import moment from 'moment-timezone'

export function GetDateInCurrentTimeZone(date : any) {
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment.tz(date, 'Universal');
  return moment(utcDate).tz(browserTZ);
}